export default {"src":"/_next/static/media/moon_filled.ca23d528.svg","height":24,"width":24};